import React from 'react';
import $ from 'jquery';
import Language from '../services/Language.js';
import utils from '../services/utils.js';
import AppModalWidget from './AppModalWidget.js';
import RequisiteNotFoundModalWidget from './RequisiteNotFoundModalWidget.js'

let inst;

class ConfirmOrderWithUpdatedTermsModalWidget extends React.Component {
    constructor(props) {
        super(props);
        if (!inst) {
            this.url = '';
            this.sendedData = {};
            this.modalObject = null;
            this.confirmUpdatedConditionsModal = null;
            this.settings = {};
            inst = this;
        }
        return inst;
    }

    callback() { }

    showUpdatedConditionsModal(url, sendedData, callback, userSettings) {
        this.settings = typeof userSettings === 'object' ? userSettings.data : {newPercent: 0, newPrice: 0};
        this.url = url;
        this.sendedData = sendedData;
        this.sendedData.fullCommission = this.settings.newPercent;
        this.sendedData.newPrice = this.settings.newPrice;
        if (typeof callback === 'function') {
            this.callback = callback;
        }

        const modalSettings = {};

        this.modalObject = $("<div />", {
            "class": "systemModal jsConfirmUpdatedConditionsModal"
        });

        this.modalObject.html(
            `<form id="confirmUpdatedConditionsModal" action="#" class="systemModal__form">
                    <div class="systemModal__controls">
                        `+ userSettings.text + `
                    </div>
                    <div class="systemModal__actions">
                        <button class="button button--green modal-approve">` + Language.getLabel('L_CONFIRM') + `</button>
                        <button class="button button--orange modal-close jsCloseModal">` + Language.getLabel('L_CLOSE') + `</button>
                    </div>
                </div>
            </form>`
        );

        this.confirmUpdatedConditionsModal = this.modalObject.find("#confirmUpdatedConditionsModal");

        const handleSubmit = (e) => {
            e && e.preventDefault();
            const showModalAgain = true;
            this.sendRequest(this.url, this.sendedData, showModalAgain);
        };

        this.confirmUpdatedConditionsModal.submit(handleSubmit);

        modalSettings.el = this.modalObject;
        modalSettings.destroyClose = true;

        modalSettings.afterShow = () => {
            this.afterShowHandler();
        };

        AppModalWidget.show(modalSettings);
    }

    afterShowHandler() { }

    clearCodeInputs() { }

    sendRequest(url, sendedData, showModalAgain = false) {
        let that = this;
        this.confirmUpdatedConditionsModal.block();
        utils.app_post(url, sendedData).then((resp) => {
            if (resp.type === 'updatedConditions' && $('.jsP2PPage').length) {
                $('.jsP2PPage')[0].dispatchEvent(new CustomEvent("updatedMoneyOutForm", {
                    detail: {
                        'newPercent': resp.data.newPercent,
                        'newPrice': resp.data.newPrice,
                    }
                }));
            } else {
                showModalAgain = false;
            }

            if (resp.type === 'requisiteNotFound') {
                if ($('.jsP2PPage').length) {
                    $('.jsP2PPage')[0].dispatchEvent(new Event("closeMoneyOutForm"));
                }

                that.close(() => {
                    RequisiteNotFoundModalWidget.showRequisiteNotFoundModal(url, sendedData, this.callback, resp);
                });
            }

            this.confirmUpdatedConditionsModal.unblock();
            if (resp.type === 'success' || resp.type === 'error' || resp.type === 'sendConfirmCode') {
                that.close(() => {
                    this.callback(resp);
                });
                return;
            }

            if (showModalAgain) {
                that.close(() => {
                    this.showUpdatedConditionsModal(this.url, this.sendedData, this.callback, resp)
                });
            }
        });
    }

    recentAnimation() { }

    close(cb) {
        if (this.modalObject) {
            AppModalWidget.close(cb);
        }
    }
}

export default new ConfirmOrderWithUpdatedTermsModalWidget();